<template>
  <div class="select-poll-contacts">
    <div
      v-for="poll in polls"
      :key="poll.id"
      @click="selectPoll(poll)"
      class="poll-item pointer"
    >
      {{ poll.title }} ({{ pollContacts(poll) }})
    </div>
  </div>
</template>
<script>
//import shared from '@/shared.js';
export default {
  name: 'SelectPoll',

  props: ['polls'],
  data() {
    return {};
  },

  computed: {},

  methods: {
    selectPoll(poll) {
      this.$emit('selectPoll', poll);
    },

    pollContacts(poll) {
      const count = poll.participants.filter( p => p.user != null).length;
      return count;
    },
  },

  created() {},
};
</script>
<style lang="scss" scoped>
.poll-item {
  padding: 5px;
  background-color: white;
  margin: 5px;
}
</style>
